import { Box, Carousel, Divider, Image, Modal, TextLink, Typography } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import { OneOnboardingImages } from "libs/images/oneOnboarding";
import { useState } from "react";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { StepByStep } from "./StepByStep";

export const Tips = () => {
    const {
        cmsData: {
            photo: {
                needSomeTips,
                close,
                photoRequirements,
                minimumSize,
                maximumSize,
                format,
                stepByStepPhotoTips,
                cleanAndTidy,
                ensureTheSpaceIsSpotless,
                straightenItemsAndSmoothSurfaces,
                optimizeLighting,
                useNaturalLightAndWhiteBulbs,
                balanceLightingToAvoidGlare,
                enhancePhotoQuality,
                useATripodAndSelfTimer,
                shootFromRoomCorners,
                showcaseUniqueFeatures,
                highlightSpecialAmenities,
                captureTheExperience,
                takeEnoughClearPhotos,
                avoidBlurryOrUnattractiveImages,
                includeExteriorsAndSurroundings,
                photographTheExteriorAndNearbyAttractions,
                forInspiration,
            },
        },
    } = useStaticDataAtomValue();
    const [modal, setModal] = useState(false);
    return (
        <Box>
            <TextLink
                label={needSomeTips}
                leadingIcon="fill.symbol.lightbulb"
                onClick={() => setModal(true)}
                data-element-name="photo-tips"
            />
            <Modal
                visible={modal}
                onClose={() => setModal(false)}
                actions={[
                    {
                        hierarchy: "primary",
                        label: close,
                        actionType: "button",
                        variant: "label",
                        onClick: () => setModal(false),
                    },
                ]}
            >
                <VStack gap="16" mt="-16">
                    <Typography variant="heading-l">{photoRequirements}</Typography>
                    <Box as="ul" m="0" ps="24">
                        <li>
                            <Typography variant="body-s">{minimumSize}</Typography>
                        </li>
                        <li>
                            <Typography variant="body-s">{maximumSize}</Typography>
                        </li>
                        <li>
                            <Typography variant="body-s">{format}</Typography>
                        </li>
                    </Box>
                </VStack>
                <Divider my="24" />
                <VStack gap="16">
                    <Typography variant="heading-l">{stepByStepPhotoTips}</Typography>
                    <StepByStep
                        title={`1. ${cleanAndTidy}`}
                        description={[ensureTheSpaceIsSpotless, straightenItemsAndSmoothSurfaces]}
                    />
                    <StepByStep
                        title={`2. ${optimizeLighting}`}
                        description={[useNaturalLightAndWhiteBulbs, balanceLightingToAvoidGlare]}
                    />
                    <StepByStep
                        title={`3. ${enhancePhotoQuality}`}
                        description={[useATripodAndSelfTimer, shootFromRoomCorners]}
                    />
                    <StepByStep title={`4. ${showcaseUniqueFeatures}`} description={[highlightSpecialAmenities]} />
                    <StepByStep
                        title={`5. ${captureTheExperience}`}
                        description={[takeEnoughClearPhotos, avoidBlurryOrUnattractiveImages]}
                    />
                    <StepByStep
                        title={`6. ${includeExteriorsAndSurroundings}`}
                        description={[photographTheExteriorAndNearbyAttractions]}
                    />
                </VStack>
                <Divider my="24" />
                <VStack gap="16">
                    <Typography variant="heading-l">{forInspiration}</Typography>
                    <Box borderRadius="8" overflow="hidden">
                        <Carousel
                            display="single"
                            accessibilityLabel="Inspiration images"
                            accessibilityPageNumberLabel="Image {0}"
                            accessibilityPreviousNavLabel="Previous image"
                            accessibilityNextNavLabel="Next image"
                            data-element-name="carousel-inspiration-photo"
                        >
                            {[
                                OneOnboardingImages.Tips1,
                                OneOnboardingImages.Tips2,
                                OneOnboardingImages.Tips3,
                                OneOnboardingImages.Tips4,
                                OneOnboardingImages.Tips5,
                                OneOnboardingImages.Tips6,
                                OneOnboardingImages.Tips7,
                            ].map((src, i) => (
                                <Image
                                    key={`inspiration-image-${i}`}
                                    alt=""
                                    src={src}
                                    width="100%"
                                    aspectRatio="square"
                                    objectFit="cover"
                                />
                            ))}
                        </Carousel>
                    </Box>
                </VStack>
            </Modal>
        </Box>
    );
};
